<template>
  <div class="filter-item">
    <span v-for="(filterItem, index) in filterList" :key="'filter_' + index">
      <label>
        <component
          :is="component"
          :filter-item="filterItem"
          :selected-items="selectedItems"
          :get-current-adult-flag-fn="getCurrentAdultFlag"
        />
      </label>
    </span>
  </div>
</template>
<script>
  import _ from 'lodash'
  import { parse } from 'query-string'
  import FilterItem from '@/pages/list/FilterItem'
  import ListFilterItem from '@/pages/list/ListFilterItem'
  import { PATH_NAME_LIST } from '@/common/resources/router.const'
  import fp from 'lodash/fp'
  export default {
    name: 'ListFilter',
    components: {
      ListFilterItem,
      FilterItem,
    },
    props: {
      filter: {
        type: Object,
      },
    },
    data() {
      return {
        filterList: [],
        selectedItems: {},
        component: null,
      }
    },
    methods: {
      getCurrentAdultFlag(filterItem, selected) {
        console.log(filterItem, selected)
        return fp.flow(
          fp.getOr([], 'filter_item_list'),
          fp.filter((option) => option.api_parameters === selected),
          fp.first,
          fp.getOr('n', 'adult'),
        )(filterItem)
      },
    },
    mounted() {
      this.filterList = _.get(this.filter, 'filterlist', [])
    },
    created() {
      const query = this.$route.query
      const defaultParameters = parse(
        _.get(this.filter, 'default_api_parameters'),
      )
      this.selectedItems = _.assign({}, defaultParameters, query)
      this.component =
        _.get(this.$route, 'name', '') === PATH_NAME_LIST
          ? 'ListFilterItem'
          : FilterItem
    },
  }
</script>
